import { BrowserRouter, Routes, Route } from "react-router-dom"
import { lazy, Suspense } from "react"
import RootLayout from "./app/layout"

/* ============================================
   Lazy-loaded routes — Code Splitting
   Reduces initial JS bundle by ~108KB.
   Each page loads its own chunk on demand.
   ============================================ */
const HomePage = lazy(() => import("./app/page"))
const SobrePage = lazy(() => import("./app/sobre/page"))
const ServicosPage = lazy(() => import("./app/servicos/page"))
const ContatoPage = lazy(() => import("./app/contato/page"))
const ClientesPage = lazy(() => import("./app/clientes/page"))
const SmartPharPage = lazy(() => import("./app/sistemas/smartphar/page"))
const SmartComPage = lazy(() => import("./app/sistemas/smartcom/page"))
const SmartChefPage = lazy(() => import("./app/sistemas/smartchef/page"))

/* ============================================
   Loading fallback — minimal skeleton
   ============================================ */
function PageLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="flex flex-col items-center gap-3">
                <div className="w-8 h-8 border-3 border-primary/30 border-t-primary rounded-full animate-spin" />
                <p className="text-sm text-muted-foreground">Carregando...</p>
            </div>
        </div>
    )
}

function App() {
    return (
        <BrowserRouter>
            <RootLayout>
                <Suspense fallback={<PageLoader />}>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/sobre" element={<SobrePage />} />
                        <Route path="/servicos" element={<ServicosPage />} />
                        <Route path="/contato" element={<ContatoPage />} />
                        <Route path="/clientes" element={<ClientesPage />} />
                        <Route path="/sistemas/smartphar" element={<SmartPharPage />} />
                        <Route path="/sistemas/smartcom" element={<SmartComPage />} />
                        <Route path="/sistemas/smartchef" element={<SmartChefPage />} />
                    </Routes>
                </Suspense>
            </RootLayout>
        </BrowserRouter>
    )
}

export default App